import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { List } from 'antd';

import i18n from '../../config/i18n';
import Link from '../shared/Link';
import PublicTestimonialSectionItem from './PublicTestimonialSectionItem';
import { getUserDataStringFromMetadata } from '../../utils';

const H2 = styled.h2`
  color: #748495;
  font-size: 34px;
  font-weight: 500;
  line-height: 46px;
  text-align: center;
`;

const Button = styled.button`
  display: block;
  margin: 30px auto;
  width: 200px;
  height: 44px;
  text-align: center;
  background: linear-gradient(to right, rgba(106,226,206,1) 0%, rgba(129,198,237,1) 100%);
  font-size: 18px;
  font-weight: 500;
  color: #fff;
  line-height: 1.42857143;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;

  &:hover {
    text-decoration: none;
  }
`;

const StyledContent = styled.div`
  margin-bottom: 100px;
`;

const PublicTestimonialSection = ({
  getPhotoDownloadURLCallback,
  medicalGroups,
  router,
  showAll,
  specialties,
  testimonials,
}) => {
  // NOTE: Get the actual MedicalGroup and Specialty model by the medicalGroupId
  // and specialtyId in User model.
  const renderItem = (item) => {
    const { medicalGroup, specialty } =
      getUserDataStringFromMetadata(item.user, medicalGroups, specialties);
    return (
      <List.Item>
        <PublicTestimonialSectionItem
          key={item.id}
          testimonial={item}
          medicalGroup={medicalGroup}
          specialty={specialty}
          getPhotoDownloadURLCallback={getPhotoDownloadURLCallback}
        />
      </List.Item>
    );
  };

  return (
    <div className="container">
      <StyledContent className="row">
        <div className="col-md-8 col-md-offset-2">
          <H2>
            {i18n.t('welcomeToTellhealMsg')}
          </H2>
        </div>
      </StyledContent>
      <List
        grid={{
          gutter: 30,
          xs: 1,
          sm: 2,
          md: 3,
          lg: 4,
        }}
        dataSource={testimonials}
        renderItem={renderItem}
      />
      {
        !showAll && (
          <StyledLink href="/testimonials" router={router}>
            <Button type="button" className="btn boca-btn">
              {i18n.t('more')}
            </Button>
          </StyledLink>
        )
      }
    </div>
  );
};

PublicTestimonialSection.propTypes = {
  getPhotoDownloadURLCallback: PropTypes.func.isRequired,
  medicalGroups: PropTypes.arrayOf(PropTypes.object),
  router: PropTypes.object.isRequired,
  showAll: PropTypes.bool,
  specialties: PropTypes.arrayOf(PropTypes.object),
  testimonials: PropTypes.arrayOf(PropTypes.object),
};

PublicTestimonialSection.defaultProps = {
  medicalGroups: [],
  showAll: true,
  specialties: [],
  testimonials: [],
};


export default PublicTestimonialSection;



// WEBPACK FOOTER //
// ./src/components/testimonial/PublicTestimonialSection.js